import { create } from '@bear-auth/core';

export const bearAuthId = create({ id: 'app' });

export const demoBearAuthId = create({ id: 'demo' });
